import type { Descendant } from 'slate';

import {
  extractResponseBodyAsJSON,
  getMultiple,
  post,
  put,
  remove,
} from '@flow/libs/oneflow-client/core';
import { camelizeKeys } from '@flow/libs/utils/camelizer';

type CreateContractNote = ({
  id,
  name,
  content,
}: {
  id: number;
  name?: string;
  content: Descendant[];
}) => Promise<any>;

export const createContractNote: CreateContractNote = ({ id, name, content }) =>
  // @ts-ignore
  post({
    url: `/agreements/${id}/notes/`,
    body: {
      name,
      content: {
        nodes: content,
      },
    },
  }).then(extractResponseBodyAsJSON);

type FetchContractNotes = ({ id }: { id: number }) => Promise<any>;

export const fetchContractNotes: FetchContractNotes = ({ id }) =>
  // @ts-ignore
  getMultiple({
    url: `/agreements/${id}/notes/`,
    pagination: {
      offset: 0,
      limit: 50,
    },
  })
    .then((response: Response) => response.json())
    .then((response: Response) => camelizeKeys(response));

type UpdateContractNote = ({
  id,
  noteId,
  name,
  content,
}: {
  id: number;
  noteId: number;
  name?: string;
  content: Descendant[];
}) => Promise<any>;

export const updateContractNote: UpdateContractNote = ({ id, noteId, name, content }) =>
  // @ts-ignore
  put({
    url: `/agreements/${id}/notes/${noteId}`,
    body: {
      name,
      content: {
        nodes: content,
      },
    },
  }).then(extractResponseBodyAsJSON);

type RemoveContractNote = ({ id, noteId }: { id: number; noteId: number }) => Promise<any>;

export const removeContractNote: RemoveContractNote = ({ id, noteId }) =>
  // @ts-ignore
  remove({
    url: `/agreements/${id}/notes/${noteId}`,
  }).then(extractResponseBodyAsJSON);
